<script setup>
import { fetchImage } from '../loadData';
const { toggleModals } = defineProps({toggleModals: Function})
</script>

<template>
<article id="welcomeMessage">
	<picture>
		<source :srcset="fetchImage('welcome-logo-dark.png')" media="(prefers-color-scheme: dark)" />
		<img :src="fetchImage('welcome-logo-light.png')" alt="The Design Externship" />
	</picture>
	<h3>
		<span>Message from the creator:</span>
		<a
			id="translate" class="btn" title="Translate"
			@click="toggleModals('language-prompt')"
			style="float:right;margin-top:-8px;"
		>
			<svg width="24" height="16" viewBox="0 0 387 275" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M247 240L261.606 202M366.5 240L352.725 202M261.606 202L301.774 97.4986C304.098 91.4521 312.681 91.5346 314.889 97.6245L352.725 202M261.606 202H352.725" stroke="var(--bg1)" stroke-width="41" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M247 240L261.606 202M366.5 240L352.725 202M261.606 202L301.774 97.4986C304.098 91.4521 312.681 91.5346 314.889 97.6245L352.725 202M261.606 202H352.725" stroke="var(--text1)" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M21 39H108M188 39H160.5M160.5 39C153 91 117.5 149.5 39.5 182M160.5 39H108M60 87.5C80.5 139.5 135 170.5 165.5 182M108 39V21" stroke="var(--bg1)" stroke-width="41" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M21 39H108M188 39H160.5M160.5 39C153 91 117.5 149.5 39.5 182M160.5 39H108M60 87.5C80.5 139.5 135 170.5 165.5 182M108 39V21" stroke="var(--text1)" stroke-width="20" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M281 10L180 265" stroke="var(--link)" stroke-width="20" stroke-linecap="round"/>
			</svg>
			<span>Translate</span>
		</a>
	</h3>
	<p>Early in my career, I was fortunate to land a contract as a UX Designer at Amazon. It took me more than 8 years of study and work-experience to get to that point, and my manager could see how eager I was to &#8220;level up&#8221;. He told me:</p>
	<blockquote>
		<p>&#8220;The only difference between a junior, a mid-level, and a senior designer is the number of answers they already have in their &#8216;back pocket&#8217;.&#8221;</p>
	</blockquote>
	<p>This collection of articles contains shared knowledge from hundreds of industry professionals. You can learn product strategy, terminology and lingo, psychology, marketing strategy, visual design, and more &mdash; a little bit of everything.</p>
	<p>Whether you&#8217;re aiming for your first job or trying to level up, I hope these links help you as much as they helped me.</p>
	<p><em>Fill your pockets.</em></p>
</article>
</template>

<style lang="scss" scoped>
#welcomeMessage {
	padding: 24px var(--container-padding) 100px;
	margin: 0 auto;
	min-height: fit-content;

	@media(min-width:768px) {
		padding-top: 8px;
		padding-bottom: 120px;
	}
	@media(min-width:1024px) {
		padding-top: 32px;
		padding-bottom: 80px;
	}

	> * { max-width: 600px; }
	picture, img {
		display: block;
		margin: 0 auto;
		width: 600px;
		max-width: 100%;
	}
	h1 {
		font-size: 2.2rem;
		font-weight: 700;
		line-height: 1.8rem;
		margin: 8px auto 24px;

		span {
			font-size: .75em;
			font-weight: 100;
		}
	}
	h3 {
		font-size: 1rem;
		font-weight: 700;
		margin: .5rem auto .6rem;
	}
	p, blockquote { margin: 1rem auto; }
}
</style>
